export default __webpack_public_path__ + "static/media/Flag_of_Libya.fa1d6c90.svg";